import { graphql } from "~/gql";

export const DELETE_UPLIFT = graphql(/* GraphQL */ `
  mutation deleteUplift($upliftId: Float!) {
    deleteUplift(upliftId: $upliftId) {
      upliftId
    }
  }
`);
